'use client';

import { c as _c } from "react/compiler-runtime";
import { TrafficOriginType } from '@cc-shopping/contracts/credit-cards-page/constants';
import { usePageAction } from '@cc-shopping/platform-analytics/hooks/usePageAction';
import { Box, Divider, Link, MenuItem, MenuList } from '@mui/material';
import { useRouter } from 'next/navigation';
import { v4 as uuid } from 'uuid';
import { ALL_SUBNAV_ITEMS } from './constants';
import { CheckmarkIcon } from './Icons/CheckmarkIcon';
import { getNavItemsForTrafficOrigin } from './utils';
type MenuItemsProps = {
  activeNavId: string;
  isMenuOpen: boolean;
  onItemClickAction: () => void;
  itemBorderRadius?: number;
  analyticsProps: {
    featureViewedActivityId: string;
  };
  trafficOriginType: TrafficOriginType;
};
export const MenuItems = t0 => {
  const $ = _c(25);
  const {
    activeNavId,
    isMenuOpen,
    onItemClickAction,
    itemBorderRadius: t1,
    analyticsProps,
    trafficOriginType: t2
  } = t0;
  const itemBorderRadius = t1 === undefined ? 2 : t1;
  const trafficOriginType = t2 === undefined ? TrafficOriginType.Organic : t2;
  const router = useRouter();
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      display: "flex",
      color: "inherit",
      textDecoration: "none",
      height: "100%",
      width: "100%",
      paddingX: 3,
      paddingY: 2,
      gap: 2,
      justifyContent: "space-between",
      alignItems: "center"
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const commonStyles = t3;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = uuid();
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== analyticsProps.featureViewedActivityId) {
    t5 = {
      actionName: "sub_nav_interaction",
      actionSection: "cc_sub_nav",
      actionType: "navigate",
      activityId: t4,
      parentActivityId: analyticsProps.featureViewedActivityId
    };
    $[2] = analyticsProps.featureViewedActivityId;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const firePageAction = usePageAction(t5);
  let t6;
  if ($[4] !== firePageAction || $[5] !== onItemClickAction || $[6] !== router) {
    t6 = (impressionPosition, subNavCategory, targetPageUrl) => {
      firePageAction({
        impression_position: impressionPosition,
        target_page_url: `${typeof window !== "undefined" && window.location.origin}${targetPageUrl}`,
        additionalAttributes: {
          sub_nav_section: "dropdown",
          sub_nav_category: subNavCategory
        }
      });
      onItemClickAction();
      router.push(targetPageUrl);
    };
    $[4] = firePageAction;
    $[5] = onItemClickAction;
    $[6] = router;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const onItemClick = t6;
  let t7;
  if ($[8] !== router) {
    t7 = url => {
      router.prefetch(url);
    };
    $[8] = router;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const handleRoutePrefetch = t7;
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      paddingY: 0
    };
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== activeNavId || $[12] !== handleRoutePrefetch || $[13] !== itemBorderRadius || $[14] !== onItemClick || $[15] !== trafficOriginType) {
    let t10;
    if ($[17] !== activeNavId || $[18] !== handleRoutePrefetch || $[19] !== itemBorderRadius || $[20] !== onItemClick) {
      t10 = (item, index) => {
        const isSelected = activeNavId === item.identifier;
        const content = <>{item.label}{isSelected && <CheckmarkIcon />}</>;
        return [<MenuItem key={item.href} onKeyDown={_temp} onMouseEnter={() => handleRoutePrefetch(item.href)} onTouchStart={() => handleRoutePrefetch(item.href)} onFocus={() => handleRoutePrefetch(item.href)} disableRipple={isSelected} sx={{
          display: "block",
          alignContent: "center",
          padding: 0,
          height: "40px",
          minHeight: "40px",
          color: "neutral.darker",
          backgroundColor: isSelected ? "greens.extraLight" : "transparent",
          fontSize: "14px",
          textDecoration: "none",
          borderRadius: itemBorderRadius,
          cursor: isSelected ? "default" : "pointer",
          "&:hover": {
            backgroundColor: isSelected ? "greens.extraLight" : "grey.100"
          },
          "&.Mui-focusVisible": {
            outlineColor: "blues.light"
          }
        }}>{isSelected ? <Box sx={commonStyles}>{content}</Box> : <Link onClick={e_0 => {
            e_0.preventDefault();
            onItemClick(index, item.href.split("/").pop() || "", item.href);
          }} href={item.href} underline="none" sx={{
            ...commonStyles,
            "&:focus-visible": {
              outline: "none"
            }
          }}>{content}</Link>}</MenuItem>, item.showDividerAfter ? <Divider key={item.href + "-divider"} sx={{
          marginY: "8px !important"
        }} /> : null];
      };
      $[17] = activeNavId;
      $[18] = handleRoutePrefetch;
      $[19] = itemBorderRadius;
      $[20] = onItemClick;
      $[21] = t10;
    } else {
      t10 = $[21];
    }
    t9 = getNavItemsForTrafficOrigin(ALL_SUBNAV_ITEMS, trafficOriginType).flatMap(t10);
    $[11] = activeNavId;
    $[12] = handleRoutePrefetch;
    $[13] = itemBorderRadius;
    $[14] = onItemClick;
    $[15] = trafficOriginType;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[22] !== isMenuOpen || $[23] !== t9) {
    t10 = <MenuList autoFocusItem={isMenuOpen} sx={t8}>{t9}</MenuList>;
    $[22] = isMenuOpen;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
};
function _temp(e) {
  if (e.key === "Enter") {
    const anchor = e.currentTarget.querySelector("a");
    anchor?.click();
  }
}